/**
 * Simple hook to fetch dynamic market price
 */
import { useState, useEffect } from 'react';
import axios from 'axios';
import { config } from '../config';

export function useMarketPrice(marketId: number | string) {
  const [price, setPrice] = useState<number>(0.5); // Default 50%
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (!marketId) return;
    
    const fetchPrice = async () => {
      try {
        const response = await axios.get(`${config.API_URL}/markets/${marketId}/amm`);
        console.log('📊 AMM Price Response:', response.data);
        if (response.data?.currentPrice !== undefined) {
          setPrice(response.data.currentPrice);
          console.log(`✅ Dynamic price updated: ${(response.data.currentPrice * 100).toFixed(1)}%`);
        }
      } catch (error) {
        console.log('⚠️ AMM endpoint error, using fallback:', error);
        // Fallback to calculating from pools if AMM endpoint doesn't exist
        try {
          const marketResponse = await axios.get(`${config.API_URL}/markets/${marketId}`);
          const market = marketResponse.data.market;
          const totalYes = market.total_yes_bets || market.totalYes || 0;
          const totalNo = market.total_no_bets || market.totalNo || 0;
          const total = totalYes + totalNo;
          if (total > 0) {
            setPrice(totalYes / total);
            console.log(`📊 Fallback price from pools: ${((totalYes / total) * 100).toFixed(1)}%`);
          }
        } catch (err) {
          console.log('Using default 50/50 price');
        }
      }
    };
    
    fetchPrice();
    // Refresh price every 5 seconds
    const interval = setInterval(fetchPrice, 5000);
    
    return () => clearInterval(interval);
  }, [marketId]);
  
  return {
    yesPrice: price,
    noPrice: 1 - price,
    yesPercent: (price * 100).toFixed(1),
    noPercent: ((1 - price) * 100).toFixed(1),
    loading
  };
}
